import React from "react";
import { RESTAURANT } from "../data/menu";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink-soft border-t border-gold/20 py-12 px-6"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10 text-center md:text-left">
        <div>
          <p className="font-serif text-3xl text-gradient-gold mb-2">Poseidon</p>
          <p className="text-xs uppercase tracking-[0.3em] text-gold/70 mb-4">
            Griechisches Restaurant · Viechtach
          </p>
          <p className="text-white/60 text-sm leading-relaxed">
            Authentische griechische Küche im Herzen des Bayerischen Waldes.
          </p>
        </div>
        <div>
          <p className="font-serif text-xl text-gold mb-3">Kontakt</p>
          <p className="text-white/70 text-sm">{RESTAURANT.address}</p>
          <a
            href={`tel:${RESTAURANT.phoneTel}`}
            className="text-white/70 hover:text-gold text-sm block mt-1"
            data-testid="footer-phone"
          >
            Tel.: {RESTAURANT.phone}
          </a>
        </div>
        <div>
          <p className="font-serif text-xl text-gold mb-3">Öffnungszeiten</p>
          <p className="text-white/70 text-sm">Mo – So · 11:30 – 13:30</p>
          <p className="text-white/70 text-sm">17:00 – 21:00 Uhr</p>
          <p className="text-gold/80 text-sm italic mt-1">Mittwoch Ruhetag</p>
        </div>
      </div>
      <div className="meander max-w-md mx-auto mt-12 opacity-60">
        <svg width="10" height="10" viewBox="0 0 14 14" fill="none">
          <path d="M7 0L9 5L14 7L9 9L7 14L5 9L0 7L5 5L7 0Z" fill="#D4AF37"/>
        </svg>
      </div>
      <p className="text-center text-white/40 text-xs mt-6">
        © {new Date().getFullYear()} Restaurant Poseidon, Viechtach. Alle Rechte vorbehalten.
      </p>
    </footer>
  );
}
